export default __webpack_public_path__ + "img/checked.c056b845.svg";